module.exports = __webpack_public_path__ + "img/bone.91d2a190.png";